import { Box } from "@chakra-ui/core";
import React from "react";

const ResetPassword = () => {
  return <Box />;
};

export default ResetPassword;
